import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Box, Divider, Stack, SvgIcon, Typography } from '@mui/material';
import {
    DateField,
    DeleteButton,
    EditButton,
    EmailField,
    FunctionField,
    ReferenceField,
    ReferenceManyField,
    SelectField,
    ShowButton,
    TextField,
    UrlField,
    useRecordContext,
} from 'react-admin';
import { AddTask } from '../tasks/AddTask';
import { TasksIterator } from '../tasks/TasksIterator';
import { TagsListEdit } from './TagsListEdit';

import { useLocation } from 'react-router';
import { useConfigurationContext } from '../root/ConfigurationContext';
import { Contact, Buyer } from '../types';

export const ContactAside = ({ link = 'edit' }: { link?: 'edit' | 'show' }) => {
    const location = useLocation();
    const { contactGender } = useConfigurationContext();
    const record = useRecordContext<Contact>();
    if (!record) return null;
    return (
        <Box ml={4} width={250} minWidth={250}>
            <Box mb={2} ml="-5px">
                {link === 'edit' ? (
                    <EditButton label="Editar Contato" />
                ) : (
                    <ShowButton label="Mostrar Contato" />
                )}
            </Box>
            <Typography variant="subtitle2">Dados pessoais</Typography>
            <Divider sx={{ mb: 2 }} />
            {record.email && (
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    minHeight={24}
                >
                    <EmailIcon color="disabled" fontSize="small" />
                    <EmailField source="email" />
                </Stack>
            )}
            {record.linkedin_url && (
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    minHeight={24}
                >
                    <LinkedInIcon color="disabled" fontSize="small" />
                    <UrlField
                        source="linkedin_url"
                        content="LinkedIn profile"
                        target="_blank"
                        rel="noopener"
                    />
                </Stack>
            )}
            {record.telefone && (
                <Stack direction="row" alignItems="center" gap={1}>
                    <PhoneIcon color="disabled" fontSize="small" />
                    <Box>
                        <TextField source="telefone" />{' '}
                        {record.tipo_telefone !== 'Other' && (
                            <TextField
                                source="tipo_telefone"
                                color="textSecondary"
                            />
                        )}
                    </Box>
                </Stack>
            )}
            {record.relacionamento && record.relacionamento.autorizado && (
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    minHeight={24}
                >
                    <AttachMoneyIcon color="disabled" fontSize="small" />
                    <Typography variant="body2" color="textSecondary">
                        Autorizado a comprar
                    </Typography>
                </Stack>
                // <Typography variant="body2" color="textSecondary" pl={3.5}>
                //     Autorizado a comprar
                // </Typography>
            )}
            <SelectField
                source="sexo"
                choices={contactGender}
                optionText={choice => (
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={1}
                        minHeight={24}
                    >
                        <SvgIcon
                            component={choice.icon}
                            color="disabled"
                            fontSize="small"
                        ></SvgIcon>
                        <span>{choice.label}</span>
                    </Stack>
                )}
                optionValue="value"
            />
            <Typography variant="subtitle2" mt={2}>
                Informações adicionais
            </Typography>
            <Divider />
            <Typography variant="body2" mt={2}>
                {record && record.observacoes}
            </Typography>
            <Box mt={1} mb={3}>
                <Typography
                    component="span"
                    variant="body2"
                    color="textSecondary"
                >
                    Cadastro:
                </Typography>{' '}
                <DateField
                    source="data_cadastro"
                    options={{ year: 'numeric', month: 'long', day: 'numeric' }}
                    color="textSecondary"
                />
                <br />
                <Typography
                    component="span"
                    variant="body2"
                    color="textSecondary"
                >
                    Atividade:
                </Typography>{' '}
                <DateField
                    source="data_hora"
                    options={{ year: 'numeric', month: 'long', day: 'numeric' }}
                    color="textSecondary"
                />
            </Box>
            <Box mb={3}>
                <Typography variant="subtitle2">Tags</Typography>
                <Divider />
                <TagsListEdit />
            </Box>
            <Box mb={3}>
                <Typography variant="subtitle2">Tarefas</Typography>
                <Divider />
                <ReferenceManyField
                    target="id_contato"
                    reference="tasks"
                    sort={{ field: 'dthr_prevista', order: 'ASC' }}
                >
                    <TasksIterator />
                </ReferenceManyField>
                <AddTask reference='suppliercontacts' />
            </Box>
            <DeleteButton redirect={location.state?.from || undefined} />
        </Box>
    );
};
